import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cv',
  templateUrl: './cv.component.html',
  styleUrls: ['./cv.component.less']
})
export class CvComponent implements OnInit {
  award_desc:any[];
  academic_service_desc:any[];
  invited_talks:any[];
  programing_languages:string[];
  tools:string[];
  process:string[];
  constructor() { 
    this.award_desc=[]
    this.academic_service_desc=[];
    this.invited_talks=[];
    this.programing_languages=[];
    this.tools=[];
    this.process=[]
  }

  ngOnInit(): void {
    this.fill_awards();
    this.fill_academic_services();
    this.fill_invited_talks();
    this.build_skills();
    
  }

  build_skills(){
    this.programing_languages=["TypeScript", "Angular2+", "Node", "JavaScript","Java", "Python", "C#", "C++", "C"]
    this.tools=["Git", "Adobe xD", "MTurk", "LATEX"]
    this.process=["Agile", "Certied Scrum Master"]
  }

  fill_awards(){
    let award1 = {"title":"Best Paper Award","desc":"SPLC-2020"}
    let award2 = {"title":"Honorable Mention Award","desc":"CHI-2020"}
    let award3 = {"title":"Graduate Teaching Assistant Fellowship","desc":"National  Institute  of  Technology,Rourkela"}
    this.award_desc.push(award1);
    this.award_desc.push(award2);
    this.award_desc.push(award3);    
  }

  fill_academic_services(){
    let academic_service1={"title":"Student Volunteer Chair", "desc":"Requirements Engineering (RE) 2021"}
    let academic_service2={"title":"Reviewer", "desc":"CHI-2021"}
    let academic_service3={"title":"Student Volunteer", "desc":"  ICSE-2019"}
    this.academic_service_desc.push(academic_service1)
    this.academic_service_desc.push(academic_service2)
    this.academic_service_desc.push(academic_service3)   
    
  }

  fill_invited_talks(){
    let invited_talk1={"desc":"Showcased DroneResponse project at the University of Gothenburg, Sweden","year":"2019"}
    let invited_talk2={"desc":"Northrop Grumman 2019 Tech Fest","year":"2019"}
    let invited_talk3={"desc":"STEM outreach seminar at the University of Notre Dame","year":"2020"}
    this.invited_talks.push(invited_talk1)
    this.invited_talks.push(invited_talk2)
    this.invited_talks.push(invited_talk3)

    
  }

}
